/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_IssuesInputs */

const en_admin_dashboard_issues = /** @type {(inputs: Admin_Dashboard_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issues`)
};

const de_admin_dashboard_issues = /** @type {(inputs: Admin_Dashboard_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Themen`)
};

const es_admin_dashboard_issues = /** @type {(inputs: Admin_Dashboard_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asuntos`)
};

const fr_admin_dashboard_issues = /** @type {(inputs: Admin_Dashboard_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problèmes`)
};

const nl_admin_dashboard_issues = /** @type {(inputs: Admin_Dashboard_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderwerpen`)
};

const it_admin_dashboard_issues = /** @type {(inputs: Admin_Dashboard_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problemi`)
};

const pt_br2_admin_dashboard_issues = /** @type {(inputs: Admin_Dashboard_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chamados`)
};

const pl_admin_dashboard_issues = /** @type {(inputs: Admin_Dashboard_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problemy`)
};

const hu_admin_dashboard_issues = /** @type {(inputs: Admin_Dashboard_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problémák`)
};

const ro_admin_dashboard_issues = /** @type {(inputs: Admin_Dashboard_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probleme`)
};

/**
* | output |
* | --- |
* | "Issues" |
*
* @param {Admin_Dashboard_IssuesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_issues = /** @type {((inputs?: Admin_Dashboard_IssuesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_IssuesInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_issues(inputs)
	if (locale === "de") return de_admin_dashboard_issues(inputs)
	if (locale === "es") return es_admin_dashboard_issues(inputs)
	if (locale === "fr") return fr_admin_dashboard_issues(inputs)
	if (locale === "nl") return nl_admin_dashboard_issues(inputs)
	if (locale === "it") return it_admin_dashboard_issues(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_issues(inputs)
	if (locale === "pl") return pl_admin_dashboard_issues(inputs)
	if (locale === "hu") return hu_admin_dashboard_issues(inputs)
	return ro_admin_dashboard_issues(inputs)
});
export { admin_dashboard_issues as "admin.dashboard.issues" }